import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-b from-gray-900 to-blue-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-800 text-white p-6 rounded-lg mb-6 shadow-lg border-l-4 border-red-500"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "break-words min-w-0" }
const _hoisted_7 = {
  key: 2,
  class: "bg-gray-800 rounded-lg shadow-xl overflow-hidden border border-blue-500"
}
const _hoisted_8 = { class: "bg-gradient-to-r from-blue-800 to-blue-600 p-6" }
const _hoisted_9 = { class: "flex items-center space-x-4" }
const _hoisted_10 = { class: "bg-blue-700 rounded-full h-20 w-20 sm:h-24 sm:w-24 flex items-center justify-center text-2xl sm:text-3xl text-white font-bold shadow-lg border-2 border-blue-300 flex-shrink-0" }
const _hoisted_11 = { class: "ml-2 min-w-0 flex-1" }
const _hoisted_12 = { class: "text-2xl sm:text-3xl font-bold text-white break-words" }
const _hoisted_13 = { class: "text-blue-200 text-base sm:text-lg break-words" }
const _hoisted_14 = {
  key: 0,
  class: "text-blue-100 mt-1 flex items-center"
}
const _hoisted_15 = { class: "break-words min-w-0" }
const _hoisted_16 = { class: "p-4 sm:p-8 bg-gradient-to-b from-gray-800 to-gray-900" }
const _hoisted_17 = { class: "bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg border border-blue-400 mb-6" }
const _hoisted_18 = { class: "space-y-6" }
const _hoisted_19 = { class: "flex flex-col sm:flex-row border-b border-gray-600 pb-4 transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_20 = { class: "text-white break-all min-w-0" }
const _hoisted_21 = { class: "flex flex-col sm:flex-row border-b border-gray-600 pb-4 transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_22 = { class: "text-white break-words min-w-0" }
const _hoisted_23 = { class: "flex flex-col sm:flex-row border-b border-gray-600 pb-4 transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_24 = { class: "text-white break-words min-w-0" }
const _hoisted_25 = { class: "flex flex-col sm:flex-row border-b border-gray-600 pb-4 transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_26 = { class: "text-white break-words min-w-0" }
const _hoisted_27 = { class: "flex flex-col sm:flex-row border-b border-gray-600 pb-4 transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_28 = { class: "text-white break-all min-w-0" }
const _hoisted_29 = { class: "flex flex-col sm:flex-row transition-all duration-200 hover:bg-gray-700 p-2 rounded-md" }
const _hoisted_30 = { class: "text-white break-words min-w-0" }
const _hoisted_31 = { class: "bg-red-900 bg-opacity-20 p-4 sm:p-6 rounded-lg shadow-lg border border-red-500 border-opacity-50" }
const _hoisted_32 = { class: "space-y-4" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_35 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_36 = {
  key: 3,
  class: "bg-gray-800 p-4 sm:p-8 rounded-lg shadow-lg text-center border border-blue-500"
}
const _hoisted_37 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_38 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-red-500 p-6 max-w-md z-10 mx-4" }
const _hoisted_39 = { class: "flex justify-end space-x-3" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-6 border-b border-blue-500 pb-2 inline-block" }, " Moj profil ", -1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-6 w-6 mr-3 text-red-300 flex-shrink-0",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  })
                ], -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.error), 1)
              ])
            ]))
          : (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userInitials), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.user.username), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                      (_ctx.user.city)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                            _cache[7] || (_cache[7] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "h-4 w-4 mr-1 flex-shrink-0",
                              viewBox: "0 0 20 20",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
                                "clip-rule": "evenodd"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.user.city), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-lg sm:text-xl font-semibold text-white mb-6 border-b border-blue-400 pb-2 flex items-center" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5 mr-2 text-blue-400 flex-shrink-0",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                          "clip-rule": "evenodd"
                        })
                      ]),
                      _createElementVNode("span", { class: "break-words min-w-0" }, "Informacije o profilu")
                    ], -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "ID korisnika:", -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.user.id), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "Korisničko ime:", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.user.username), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "Ime:", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.user.firstName || 'Nije uneto'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "Prezime:", -1)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.user.lastName || 'Nije uneto'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "Email:", -1)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.user.email), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-blue-300 sm:w-32 font-medium mb-1 sm:mb-0 flex-shrink-0" }, "Grad:", -1)),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.user.city || 'Nije unet'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-lg sm:text-xl font-semibold text-red-400 mb-4 border-b border-red-500 border-opacity-50 pb-2 flex items-center" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5 mr-2 text-red-400 flex-shrink-0",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                          "clip-rule": "evenodd"
                        })
                      ]),
                      _createElementVNode("span", { class: "break-words min-w-0" }, "Opasna zona")
                    ], -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-red-300 text-sm mb-4" }, " Brisanje naloga je nepovratna akcija. Svi vaši podaci, proizvodi, poruke i ocene će biti trajno obrisani. ", -1)),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDeleteConfirmation && _ctx.showDeleteConfirmation(...args))),
                          disabled: _ctx.deleteLoading,
                          class: "bg-red-600 text-white px-6 py-3 rounded-md hover:bg-red-700 transition-colors shadow-lg text-sm sm:text-base font-medium flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                        }, [
                          (_ctx.deleteLoading)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_34, _cache[15] || (_cache[15] = [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }, null, -1),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_35, _cache[16] || (_cache[16] = [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
                                  "clip-rule": "evenodd"
                                }, null, -1)
                              ]))),
                          _createTextVNode(" " + _toDisplayString(_ctx.deleteLoading ? 'Brisanje...' : 'Obriši nalog'), 1)
                        ], 8, _hoisted_33)
                      ])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"bg-blue-900 w-16 h-16 sm:w-24 sm:h-24 rounded-full flex items-center justify-center mx-auto mb-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-10 w-10 sm:h-16 sm:w-16 text-blue-300\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z\"></path></svg></div><h3 class=\"text-xl sm:text-2xl font-medium text-white mt-4\"> Podaci o profilu nisu dostupni </h3><p class=\"text-blue-300 mt-2 mb-6 break-words\"> Pokušajte ponovo kasnije ili se odjavite pa prijavite </p>", 3)),
                _createElementVNode("button", {
                  class: "bg-blue-600 text-white px-4 py-2 sm:px-6 sm:py-3 rounded-md hover:bg-blue-500 transition-colors shadow-lg text-sm sm:text-base",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchUserProfile && _ctx.fetchUserProfile(...args)))
                }, " Pokušaj ponovo ")
              ]))
    ]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" }, null, -1)),
          _createElementVNode("div", _hoisted_38, [
            _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"flex items-start mb-4\"><div class=\"flex-shrink-0 mr-4\"><svg class=\"h-8 w-8 text-red-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\"></path></svg></div><div class=\"flex-1\"><h3 class=\"text-lg font-medium text-red-400 mb-2\"> Potvrda brisanja naloga </h3><p class=\"text-gray-300 text-sm\"> Da li ste sigurni da želite da obrišete svoj nalog? Ova akcija je nepovratna i svi vaši podaci će biti trajno obrisani. </p></div></div>", 1)),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelDelete && _ctx.cancelDelete(...args))),
                class: "px-4 py-2 text-gray-300 hover:text-white transition-colors"
              }, " Otkaži "),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                disabled: _ctx.deleteLoading,
                class: "px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              }, [
                (_ctx.deleteLoading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _cache[21] || (_cache[21] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.deleteLoading ? 'Brisanje...' : 'Da, obriši nalog'), 1)
              ], 8, _hoisted_40)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}